module.exports = __webpack_public_path__ + "img/r-9.48af2708.jpg";